import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=67f7829a&scoped=true"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=67f7829a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7829a",
  null
  
)

export default component.exports